import { render, staticRenderFns } from "./logistics-list.vue?vue&type=template&id=bd71ae42"
import script from "./logistics-list.vue?vue&type=script&lang=ts"
export * from "./logistics-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports